"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleepAsync = void 0;
/**
 * Returns a simple promise that will be resolved within a discrete timeout
 * @param timeout The timeout in millisecs
 */
const sleepAsync = (timeout = 250) => new Promise((resolve) => setTimeout(() => {
    resolve();
}, timeout));
exports.sleepAsync = sleepAsync;
//# sourceMappingURL=sleep-async.js.map